import { Controller } from "@hotwired/stimulus";
import Trix from "trix";
import { post } from "@rails/request.js";
import Toast from "../toast_controller.js";

export default class extends Controller {
  initialize(event) {
    if (!event) {
      return;
    }

    const trixEditor = event.target;
    const toolbarElement = trixEditor.toolbarElement;

    trixEditor.parentElement.classList.add("relative");
    trixEditor.parentElement.insertAdjacentHTML(
      "beforeend",
      `<button type="button" 
            class="btn btn-white btn-sm border absolute bottom-2 right-2" 
            data-trix-action="x-generate-ai-description" 
            title="Generate AI description" 
id="ai-button"
            tabindex="-1">
Write with AI
    </button>`,
    );

    // Find the "insert file" button and insert our AI button after it
    const fileGroup = toolbarElement.querySelector(
      ".trix-button-group--file-tools",
    );

    if (fileGroup) {
      // Add click event for the AI generate button
      const aiButton = document.querySelector("#ai-button");

      if (aiButton) {
        aiButton.addEventListener("click", function (event) {
          let spinner = `
<svg class="mr-3 -ml-1 size-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
`;
          aiButton.innerHTML = spinner + " Generating AI description...";
          aiButton.disabled = true;
          aiButton.classList.add("cursor-not-allowed", "opacity-50");
          event.preventDefault();

          // Show loading indicator in the editor
          const editor = trixEditor.editor;
          trixEditor.focus();
          const length = editor.getDocument().toString().length;

          // Move the cursor to the end
          editor.setSelectedRange([0, length - 1]);

          // Get the property ID or set to 'new' for new properties
          let propertyForm =
            trixEditor.parentElement.querySelector("input").form;

          const formData = new FormData();

          if (propertyForm) {
            for (let element of propertyForm.elements) {
              formData.append(element.name, element.value);
            }
          }

          post(`/app/properties/generate_description_preview`, {
            body: formData,
          })
            .then(async (response) => {
              let data = await response.json;

              if (data.description) {
                editor.deleteInDirection("forward");

                editor.insertHTML(data.description);
              } else {
                Toast.trigger({
                  title: "Error",
                  message:
                    "⚠️ Failed to generate description. Please try again or write your own",
                });
              }
            })
            .catch((error) => {
              Toast.trigger({
                title: "Error",
                message: "Failed to generate description. Please try again.",
              });
            })
            .finally(() => {
              aiButton.innerHTML = "Write with AI";
              aiButton.disabled = false;
              aiButton.classList.remove("cursor-not-allowed", "opacity-50");
            });
        });
      }
    }
  }
}
